import React, { useEffect, useState } from "react";

/**
 * Enhanced Premium Footer Component
 * UPDATED: Refined gradients with a subtle orange/amber accent for warmth.
 * IMPROVED: Multi-tone light bleeds for a more dynamic tech-noir feel.
 */
const Footer = ({ account }) => {
  const [offlineList, setOfflineList] = useState([]);

  useEffect(() => {
    const mockData = [
      "Design Verification",
      "Physical Design",
      "Design For Testability",
      "Internship Programs",
      "VLSI Architecture",
    ];
    setOfflineList(mockData);
  }, []);

  // --- UI ASSETS ---
  const Icons = {
    ChevronRight: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>,
    Phone: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
    Envelope: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>,
    Linkedin: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>,
    Instagram: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>,
    Youtube: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/></svg>,
    Whatsapp: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.412 2.503 1.112 3.487l-1.18 4.312 4.414-1.159c.946.549 2.037.866 3.203.868 3.182 0 5.767-2.586 5.768-5.766-.001-3.182-2.587-5.769-5.769-5.77zm3.361 8.24c-.143.402-.821.737-1.137.784-.298.044-.684.072-1.104-.06-.23-.072-.519-.172-.888-.331-1.569-.674-2.588-2.256-2.666-2.359-.079-.103-.644-.859-.644-1.638 0-.779.408-1.161.554-1.314.145-.154.316-.192.421-.192h.302c.11 0 .252-.041.393.298.145.346.494 1.205.537 1.292.043.087.072.188.014.302-.058.115-.087.188-.173.288l-.26.303c-.087.095-.178.199-.077.372.101.174.449.741.964 1.201.663.591 1.22.774 1.393.861.173.088.274.072.376-.045.101-.117.433-.504.55-.678.115-.173.231-.144.39-.087s1.011.477 1.184.564.289.13.332.202c.045.072.045.419-.098.821z"/></svg>,
    Facebook: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.324v-21.35c0-.732-.593-1.325-1.325-1.325z"/></svg>,
    Twitter: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/></svg>
  };

  return (
    <footer className="footer-premium position-relative overflow-hidden">
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" />
      
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

        /* REDUCED VIBRANCY PALETTE: Muted Indigo, Obsidian & Amber Glow */
        .footer-premium { 
          background: #080c14; /* Darker obsidian base */
          font-family: 'Inter', sans-serif;
          padding-top: 100px;
          color: #f8fafc;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E");
          background-blend-mode: overlay;
        }

        /* REFINED MESH BACKGROUND */
        .stellar-bg {
          position: absolute;
          inset: 0;
          z-index: 0;
          background: 
            radial-gradient(circle at 10% 20%, rgba(99, 102, 241, 0.05) 0%, transparent 40%),
            radial-gradient(circle at 90% 80%, rgba(245, 158, 11, 0.04) 0%, transparent 40%), /* Soft Amber */
            radial-gradient(circle at 50% 50%, rgba(15, 23, 42, 1) 0%, transparent 100%);
        }

        /* DYNAMIC LIGHT ORBS WITH AMBER ACCENT */
        .glow-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(140px);
          opacity: 0.1;
          animation: gentlePulse 25s infinite alternate ease-in-out;
        }
        .orb-1 { top: -10%; left: -5%; width: 45vw; height: 45vw; background: #6366f1; }
        .orb-2 { bottom: -15%; right: 5%; width: 40vw; height: 40vw; background: #f59e0b; animation-delay: -7s; opacity: 0.06; } /* Orange Orb */
        .orb-3 { top: 30%; right: 20%; width: 20vw; height: 20vw; background: #14b8a6; animation-delay: -12s; opacity: 0.03; }
        
        @keyframes gentlePulse {
          0% { transform: translate(0, 0) scale(1); opacity: 0.05; }
          100% { transform: translate(40px, 40px) scale(1.1); opacity: 0.12; }
        }

        .brand-name {
          font-size: 34px;
          font-weight: 800;
          letter-spacing: -1.2px;
          color: #ffffff;
          background: linear-gradient(180deg, #ffffff 40%, #fde68a 120%); /* Subtle gold tint in text */
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 1rem;
        }

        /* Square Social Links */
        .social-link {
          width: 48px; height: 48px; border-radius: 12px;
          display: inline-flex; align-items: center; justify-content: center;
          transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.2);
          text-decoration: none; margin-right: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.4);
        }
        .social-link:hover { transform: translateY(-5px) scale(1.05); }

        .sl-linkedin { background: #0077b5; }
        .sl-instagram { background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%); }
        .sl-youtube { background: #ff0000; }
        .sl-whatsapp { background: #25d366; }
        .sl-facebook { background: #1877f2; }
        .sl-twitter { background: #000000; } /* Modern X/Twitter look */

        .footer-section-title {
          font-size: 11px; font-weight: 700; text-transform: uppercase;
          letter-spacing: 2px; color: #475569; margin-bottom: 32px;
          display: flex; align-items: center;
        }
        .title-accent {
          width: 5px; height: 5px; background: #f59e0b; /* Amber accent */
          margin-right: 12px; border-radius: 1px; transform: rotate(45deg);
        }

        /* Refined Contact Cards */
        .contact-card {
          padding: 16px; border-radius: 16px; 
          background: rgba(255, 255, 255, 0.015);
          border: 1px solid rgba(255, 255, 255, 0.03); 
          margin-bottom: 14px; transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .contact-card:hover { 
          background: rgba(255, 255, 255, 0.03); 
          border-color: rgba(245, 158, 11, 0.2); /* Soft orange border on hover */
          transform: translateX(4px);
        }
        .contact-icon {
          min-width: 36px; height: 36px; border-radius: 10px;
          background: rgba(245, 158, 11, 0.08); color: #fbbf24;
          display: flex; align-items: center; justify-content: center;
        }

        .nav-item-link {
          display: flex; align-items: center; gap: 10px; font-size: 14px;
          color: #64748b; margin-bottom: 16px; cursor: pointer;
          transition: 0.3s ease; text-decoration: none;
        }
        .nav-item-link:hover { color: #f1f5f9; padding-left: 6px; }
        .nav-item-link svg { opacity: 0; transition: 0.3s; color: #f59e0b; }
        .nav-item-link:hover svg { opacity: 1; }

        .footer-bottom {
          margin-top: 100px; padding: 40px 0; border-top: 1px solid rgba(255,255,255,0.03);
          font-size: 13px; color: #334155;
        }
        .legal-link { color: #334155; text-decoration: none; margin-left: 24px; transition: 0.2s; }
        .legal-link:hover { color: #f59e0b; }

        @media (max-width: 991px) {
          .footer-section-title { margin-top: 30px; }
        }
      `}</style>

      {/* Subtle Layered Backgrounds */}
      <div className="stellar-bg"></div>
      <div className="glow-orb orb-1"></div>
      <div className="glow-orb orb-2"></div>
      <div className="glow-orb orb-3"></div>

      <div className="container position-relative" style={{ zIndex: 10 }}>
        {/* Branding Header */}
        <div className="row mb-5 pb-5 border-bottom border-white border-opacity-5 align-items-center">
          <div className="col-lg-6">
            <h2 className="brand-name">SiliconMinds</h2>
            <p className="text-secondary mb-0" style={{ maxWidth: "450px", fontSize: "15px", color: "#64748b !important", lineHeight: "1.6" }}>
              The definitive resource for VLSI and Embedded Systems expertise. 
              Bridging the gap between academic learning and industrial implementation.
            </p>
          </div>
          <div className="col-lg-6 text-lg-end mt-4 mt-lg-0">
            <div className="d-flex justify-content-lg-end gap-1">
              <a href="https://www.linkedin.com/company/siliconminds-technologies/" className="social-link sl-linkedin"><Icons.Linkedin /></a>
              <a href="https://www.instagram.com/siliconminds_tech?utm_source=qr&igsh=MTB3YmN4emZ6NGJsag==" className="social-link sl-instagram"><Icons.Instagram /></a>
              {/* <a href="#" className="social-link sl-youtube"><Icons.Youtube /></a> */}
              <a 
  href="https://wa.me/919986783238" 
  target="_blank" 
  rel="noopener noreferrer"
  className="social-link sl-whatsapp"
>
  <Icons.Whatsapp />
</a>
              <a href="https://www.facebook.com/share/18Hn8WdNS6/" className="social-link sl-facebook"><Icons.Facebook /></a>
              {/* <a href="#" className="social-link sl-twitter"><Icons.Twitter /></a> */}
            </div>
          </div>
        </div>

        {/* Links Grid */}
        <div className="row gy-4">
          <div className="col-lg-3 col-md-6">
            <h6 className="footer-section-title"><span className="title-accent"></span>Contact</h6>
            <div className="contact-card d-flex align-items-center gap-3">
              <div className="contact-icon"><Icons.Phone /></div>
              <div>
                <div style={{color:'#475569', fontSize:'10px', textTransform:'uppercase', fontWeight:800, letterSpacing:'1px'}}>Support Line</div>
                <div className="fw-medium text-white-50" style={{fontSize:'14px'}}>+91 9986783238</div>
              </div>
            </div>
            <div className="contact-card d-flex align-items-center gap-3">
              <div className="contact-icon"><Icons.Envelope /></div>
              <div>
                <div style={{color:'#475569', fontSize:'10px', textTransform:'uppercase', fontWeight:800, letterSpacing:'1px'}}>Email Query</div>
                <div className="fw-medium text-white-50" style={{fontSize:'14px'}}>info@siliconmindstech.com</div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="footer-section-title"><span className="title-accent"></span>VLSI Training</h6>
            <div className="ps-1">
              {offlineList.map((course, i) => (
                <div key={i} className="nav-item-link"><Icons.ChevronRight />{course}</div>
              ))}
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="footer-section-title"><span className="title-accent"></span>Organization</h6>
            <div className="ps-1">
              {["Industrial Methodology", "Research Wing", "Corporate Alliances", "Careers", "Alumni Hub"].map((s, i) => (
                <div key={i} className="nav-item-link"><Icons.ChevronRight />{s}</div>
              ))}
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="footer-section-title"><span className="title-accent"></span>Resources</h6>
            <div className="ps-1">
              {["Knowledge Center", "Privacy Policy", "Terms of Service", "Help Desk"].map((s, i) => (
                <div key={i} className="nav-item-link"><Icons.ChevronRight />{s}</div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <p className="mb-0 text-white">
                &copy; {new Date().getFullYear()} <span className="text-white-50">SiliconMinds Technologies</span>. Engineered with Precision.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end mt-3 mt-md-0">
              <a href="#" className="legal-link">Security</a>
              <a href="#" className="legal-link">Privacy</a>
              <a href="#" className="legal-link">Compliance</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;